import { render, staticRenderFns } from "./ListItemNumber.vue?vue&type=template&id=528ac8a2&scoped=true&"
import script from "./ListItemNumber.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ListItemNumber.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528ac8a2",
  null
  
)

export default component.exports